import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { BaseExampleService, type BilingualExample } from '@/features/checking/domains/common/services/base-example-service';
import { HeaderServiceProxy } from '@/services/header-service-proxy';
import demoFile1Url from '@/assets/drafting/demo-files/一种自适应多级阻尼缓冲器.docx?url';
import demoFile2Url from '@/assets/drafting/demo-files/一种具有核壳结构的原位掺杂型高导热锂电池隔膜及其制备工艺.docx?url';
import demoFile3Url from '@/assets/drafting/demo-files/一种基于AI对话的全链路语音交易系统及实现方法.docx?url';

import demoFile4Url from '@/assets/drafting/demo-files/A Full-link Voice Transaction System and Implementation Method Based on AI Dialogue.docx?url';
import demoFile5Url from '@/assets/drafting/demo-files/An Adaptive Multi-stage Damping Buffer.docx?url';
import demoFile6Url from '@/assets/drafting/demo-files/An In-Situ Doped High Thermal Conductivity Lithium Battery Separator with Core-Shell Structure and Its Preparation Process.docx?url';

export const DisclosureExampleService = Symbol('DisclosureExampleService');
export interface DisclosureExampleService extends BaseExampleService {}

@injectable()
export class DisclosureExampleServiceImpl extends BaseExampleService implements DisclosureExampleService {
    constructor(
        @inject(HeaderServiceProxy)
        private headerServiceProxy: HeaderServiceProxy
    ) {
        super();
    }

    siteRegion() {
        return this.headerServiceProxy?.headerService?.account?.siteRegion;
    }

    getExamples() {
        if (!this.siteRegion()) {
            return [];
        }

        const examples = {
            CN: [
                {
                    text: '一种自适应多级阻尼缓冲器.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '69079bda-179c-491e-8f8f-ef1c2527fddc',
                        },
                        files: [
                            { url: demoFile1Url, name: '一种自适应多级阻尼缓冲器.docx' }
                        ],
                    },
                },
                {
                    text: '一种具有核壳结构的原位掺杂型高导热锂电池隔膜及其制备工艺.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'c7d97912-de74-49b0-94e1-db311b90ac62',
                        },
                        files: [
                            { url: demoFile2Url, name: '一种具有核壳结构的原位掺杂型高导热锂电池隔膜及其制备工艺.docx' }
                        ],
                    },
                },
                {
                    text: '一种基于AI对话的全链路语音交易系统及实现方法.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '16470b3a-1ab8-4269-9782-7c5c5e59766a',
                        },
                        files: [
                            { url: demoFile3Url, name: '一种基于AI对话的全链路语音交易系统及实现方法.docx' }
                        ],
                    },
                }
            ],
            US: [
                {
                    text: 'A Full-link Voice Transaction System and Implementation Method Based on AI Dialogue.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '95ed8ee7-547c-404f-9cfc-cf19ada0e8ba',
                        },
                        files: [
                            { url: demoFile4Url, name: 'A Full-link Voice Transaction System and Implementation Method Based on AI Dialogue.docx' }
                        ],
                    },
                },
                {
                    text: 'An Adaptive Multi-stage Damping Buffer.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '07abaa20-ffe9-45a6-8efe-afca8305942b',
                        },
                        files: [
                            { url: demoFile5Url, name: 'An Adaptive Multi-stage Damping Buffer.docx' }
                        ],
                    },
                },
                {
                    text: 'An In-Situ Doped High Thermal Conductivity Lithium Battery Separator with Core-Shell Structure and Its Preparation Process.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'b92e1ff1-26c9-49c9-b025-66148cd8986b',
                        },
                        files: [
                            { url: demoFile6Url, name: 'An In-Situ Doped High Thermal Conductivity Lithium Battery Separator with Core-Shell Structure and Its Preparation Process.docx' }
                        ],
                    },
                }
            ],
            EU: [
                {
                    text: 'A Full-link Voice Transaction System and Implementation Method Based on AI Dialogue.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'c02347fb-d428-49a0-9dee-212e9b52793a',
                        },
                        files: [
                            { url: demoFile4Url, name: 'A Full-link Voice Transaction System and Implementation Method Based on AI Dialogue.docx' }
                        ],
                    },
                },
                {
                    text: 'An Adaptive Multi-stage Damping Buffer.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: 'a6a8e66a-118d-435e-8e7b-40d09180a601',
                        },
                        files: [
                            { url: demoFile5Url, name: 'An Adaptive Multi-stage Damping Buffer.docx' }
                        ],
                    },
                },
                {
                    text: 'An In-Situ Doped High Thermal Conductivity Lithium Battery Separator with Core-Shell Structure and Its Preparation Process.docx',
                    other: {
                        path: '/#/patent-drafting',
                        query: {
                            project_id: '81786ff9-e217-4805-bcc5-d49b41b5bd80',
                        },
                        files: [
                            { url: demoFile6Url, name: 'An In-Situ Doped High Thermal Conductivity Lithium Battery Separator with Core-Shell Structure and Its Preparation Process.docx' }
                        ],
                    },
                }
            ],
        }

        return examples[this.siteRegion()!] || [];
    }

    protected getExamplesData(): BilingualExample[] {
        return [];
    }
}
